'use client';

import { Button } from '@ahafood/ui/components/button';
import { Input } from '@ahafood/ui/components/input';
import { motion } from 'framer-motion';
import { SearchIcon } from 'lucide-react';

interface SearchInterfaceProps {
  showSearch: boolean;
  searchQuery: string;
  isMobile: boolean;
  onSearchChange: (value: string) => void;
  onCancel: () => void;
}

export function SearchInterface({
  showSearch,
  searchQuery,
  isMobile,
  onSearchChange,
  onCancel,
}: SearchInterfaceProps) {
  return (
    <motion.div
      id="search-interface"
      initial={{ opacity: 0, height: 0 }}
      animate={{
        opacity: showSearch || !isMobile ? 1 : 0,
        height: showSearch || !isMobile ? 'auto' : 0,
      }}
      transition={{ duration: 0.3 }}
      className={`overflow-hidden sticky z-50 ${
        isMobile ? 'top-0 md:w-full' : 'md:w-full top-20'
      }`}
    >
      <div className="p-4 bg-white border-b">
        <div className="flex items-center gap-3 relative">
          <div
            className="absolute left-3 text-neutral-50 cursor-pointer hover:text-neutral-80 transition-colors"
            onClick={() => {
              document.getElementById('store-search-input')?.focus();
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                document.getElementById('store-search-input')?.focus();
              }
            }}
            role="button"
            tabIndex={0}
            aria-label="Tìm kiếm"
          >
            <SearchIcon className="size-5" />
          </div>
          <Input
            id="store-search-input"
            className="flex-1 border-none placeholder:text-neutral-40 bg-neutral-10 pl-10 text-base font-normal h-12"
            placeholder="Bạn cần tìm gì...."
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') e.preventDefault();
            }}
          />
          <Button
            variant="ghost"
            className="text-red-40 hover:text-red-60 hover:bg-transparent py-0 px-4 font-bold"
            onClick={onCancel}
          >
            Hủy
          </Button>
        </div>
      </div>
    </motion.div>
  );
}
